import { take, put, call, select, takeLatest } from 'redux-saga/effects';
import { EventChannel } from 'redux-saga';
import * as constants from '../../resource/user/user.constants';
import { IPusherAction, createSagaEventChannelForPusherChannel } from './pusher.connection';
import { SOCKET_CONFIG } from '../socket.configs';
import { userSelectors } from '../../resource/user/user.selectors';
import { authSelectors } from '../../auth/auth.selectors';
import { IUser } from '../../resource/user/user.types';
import { addFlashMessage } from '../../../utils/flashMessages.utils';

export function* watchOnPusherUserPings() {
  try {
    const currentId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
    const user = (yield select(userSelectors.selectResourceById, currentId)) as IUser;

    if (!user) {
      console.error('The user is not loaded when setting up Pusher channels.');
      addFlashMessage({
        type: 'error',
        message: 'Your session was not properly loaded, please refresh the page.',
        reloadOnCountdown: true,
      });
      return;
    }

    const socketChannel = (yield call(
      createSagaEventChannelForPusherChannel,
      `acc-${user.tenantId}`,
      SOCKET_CONFIG.actions,
    )) as EventChannel<IPusherAction>;

    while (true) {
      try {
        // An error from socketChannel will cause the saga jump to the catch block
        const action = (yield take(socketChannel)) as IPusherAction;
        yield put(action);
        // yield fork(pusher);
      } catch (err) {
        console.error('User socket error:', err);
        // socketChannel is still open in catch block
        // if we want to end the socketChannel, we need to close it explicitly
        // socketChannel.close()
      }
    }
  } catch (error) {
    console.error('Error in "watchOnPusherUserPings"', error);
    addFlashMessage({
      type: 'error',
      message: `There was a problem loading the site interactivity. Changes won't properly reflect until you refresh the page.`,
      reloadOnCountdown: true,
    });
  }
}

export function* pusherUserSagaWatcher() {
  yield takeLatest(constants.STORE_USER, watchOnPusherUserPings);
}
